import request from '@/router/axios'

const urlPrefix = '/sys'

// 总体预算-列表
export function getAllBudget(data) {
  return request({
    url: urlPrefix + '/cofcodata/getAllBudget',
    method: 'post',
    data
  })
}

// 总体预算-列表-新增
export function addAllBudget(data) {
  return request({
    url: urlPrefix + '/cofcodata/addAllBudget',
    method: 'post',
    data
  })
}

// 总体预算-列表-修改
export function updateAllBudget(data) {
  return request({
    url: urlPrefix + '/cofcodata/updateAllBudget',
    method: 'post',
    data
  })
}

// 总体预算-列表-删除
export function deleteAllBudget(data) {
  return request({
    url: urlPrefix + '/cofcodata/deleteAllBudget',
    method: 'post',
    data
  })
}

// 员工薪酬水平-列表
export function getESLD(data) {
  return request({
    url: urlPrefix + '/cofcodata/getESLD',
    method: 'post',
    data
  })
}

// 员工薪酬水平-下载模板
export function getESLDTemplate(data) {
  return request({
    url: urlPrefix + '/cofcodata/getESLDTemplate',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}

// 员工薪酬水平-上传模板
export function uploadESLDTemplate(data) {
  return request({
    url: urlPrefix + '/cofcodata/uploadESLDTemplate',
    method: 'post',
    data
  })
}

// 员工薪酬水平-新增
export function addESLD(data) {
  return request({
    url: urlPrefix + '/cofcodata/addESLD',
    method: 'post',
    data
  })
}

// 员工薪酬水平-编辑
export function updateESLD(data) {
  return request({
    url: urlPrefix + '/cofcodata/updateESLD',
    method: 'post',
    data
  })
}

// 员工薪酬水平-删除
export function deleteESLD(data) {
  return request({
    url: urlPrefix + '/cofcodata/deleteESLD',
    method: 'post',
    data
  })
}
